import { P2GButton, P2GDialog, P2GGrid, P2GText, P2GTextField } from '@parcel2go/core-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

export const PostcodePrompt: React.FC<{
  dataTestId?: string;
  onCancel: () => void;
  showPostcode: boolean;
  postcode: string | undefined;
  onSubmit: (v: string) => void;
}> = ({ showPostcode, postcode, onCancel, onSubmit, dataTestId }) => {
  const { t } = useTranslation([TranslationNamespaces.QUOTE]);
  const [query, setQuery] = useState(postcode || '');
  return (
    <P2GDialog
      dataTestId={dataTestId}
      title={t('QUOTE_POSTCODE_DIALOG_TITLE', { defaultValue: 'Enter your postcode' })}
      open={showPostcode}
      onClose={onCancel}
      content={
        <P2GGrid container spacing={2} direction="column">
          <P2GGrid item>
            <P2GText component="p">
              {t('QUOTE_POSTCODE_DIALOG_CONTENT', {
                defaultValue: 'Please enter your postcode to get accurate dropshop locations.'
              })}
            </P2GText>
          </P2GGrid>
          <P2GGrid item>
            <P2GTextField
              label={t('QUOTE_POSTCODE_DIALOG_TEXTBOX_LABEL', { defaultValue: 'Postcode' })}
              value={query}
              onChange={(e) => setQuery(e.currentTarget.value)}
              fullWidth
            />
          </P2GGrid>
        </P2GGrid>
      }
      actions={
        <P2GButton onClick={() => onSubmit(query)}>
          {t('QUOTE_POSTCODE_DIALOG_BUTTON', { defaultValue: 'Submit' })}
        </P2GButton>
      }
    />
  );
};
